module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "china-item",
    attrs: {
      "id": "huiju-wrapper"
    }
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": _vm.chinaImg3,
      "title": "汇集臻品"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "china-content-3"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": item.tip
      }
    })])], 1)
  }), 0)]), _vm._v(" "), (_vm.hasMore) ? _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "id": "china-more"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.chinaImg4,
      "title": "更多老字号"
    },
    on: {
      "click": _vm.fetchData
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.hasMore) ? _c('Alert', {
    attrs: {
      "type": "warning",
      "show-icon": ""
    }
  }, [_vm._v("\n\t\t        温馨提示\n\t\t        "), _c('template', {
    slot: "desc"
  }, [_vm._v("\n\t\t        没有更多数据\n\t\t    \t")])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3afa341f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/china-time-honored/influx.vue
// module id = 1577
// module chunks = 1